
import urls from "../configmap/config.json";

const clientId = "0oa1zz8euhrhm8N6j0h8";

export const oktaConfig = {
  issuer: urls.issuer,
  clientId:clientId,
  redirectUri: `/authorization_code/callback`,
  scopes: ["openid", "profile", "email"],
  pkce: true,
};